<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.filter"
      @keydown.esc="dialog.filter = false"
      @keydown.enter="dialog.filter = false; dialog.fullscreen = false; fetch();"
      :fullscreen="dialog.fullscreen"
      width="550"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Filter Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.filter = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <div>
              <p class="body-2 mt-4 mb-2">
                Unit
              </p>

              <v-select
                filled
                rounded
                dense
                single-line
                hide-details
                :color="set_color"
                :item-color="set_color"
                placeholder="Contoh. Retail dan Kuliner"
                :items="unit"
                clearable
                @click:clear="filter.unit = ''"
                v-model="filter.unit"
                class="mb-4"
                style="width: 70%; border-radius: 10px !important;">
              </v-select>
            </div>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.filter = false; dialog.fullscreen = false; fetch();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.freeze"
      @keydown.esc="dialog.freeze = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Freeze Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in configHeaders" 
                        :key="index"
                        class="px-0"
                        @click="item.freeze = !item.freeze ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.freeze">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.freeze ? 'font-weight-bold' : ''"
                            :style="item.freeze ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Freeze
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.hide"
      @keydown.esc="dialog.hide = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hide Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.hide = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in headers" 
                        :key="index"
                        class="px-0"
                        @click="item.hide = !item.hide ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.hide">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.hide ? 'font-weight-bold' : ''"
                            :style="item.hide ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Hide
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.attachment"
      @keydown.esc="dialog.attachment = false"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card v-if="selected.row.length > 0"
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title 
          class="d-flex align-center py-0 px-3 text-right popup-header">
          Lampiran

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.attachment = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <v-img
            width="100%"
            height="auto"
            alt="umb" 
            :src="selected.row[0].attachment"
            class="ma-auto border-radius">
            <template v-slot:placeholder>
              <v-row
                class="fill-height"
                align="center"
                justify="center">
                <v-progress-circular 
                  indeterminate 
                  :color="set_color">
                </v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.map"
      @keydown.esc="dialog.map = false"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card v-if="markers.length > 0"
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title
          class="d-flex align-center py-0 px-3 text-right popup-header">
          {{ markers[0].name }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.map = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <gmap-map
            ref="gmap"
            :center="center"
            :zoom="12"
            :scrollwheel="false"
            style="width:100%;"
            :style="!dialog.fullscreen ? 'height: calc(100vh - 300px);' : 'height: calc(100vh - 100px);'">

            <gmap-marker
              v-for="(item, index) in markers"
              :key="index"
              :position="item.latlng"
              :icon="item.icon"
              @click="toggleInfoWindow(item, index)">
            </gmap-marker>

            <gmap-info-window
              :options="infoOptions"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen=false">
              <div v-html="infoContent"></div>
            </gmap-info-window>
          </gmap-map>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col 
                cols="12" 
                md="8" 
                class="d-flex align-center">
                <div class="mr-3">
                  <v-btn
                    elevation="0"
                    dark
                    style="border-radius: 10px;"
                    :color="set_color"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center"
                    @click="dialog.filter = true; fetchUnit();">
                    <v-icon size="18">mdi-filter-outline</v-icon>

                    <span class="ml-1">
                      Filter
                    </span>
                  </v-btn>
                </div>
                
                <div class="mr-3" v-if="selected.row.length === 1">
                  <v-btn
                    elevation="0"
                    style="background: #e0e0e0; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center text-second"
                    @click="dialog.attachment = true">
                    <v-icon size="18">mdi-paperclip</v-icon>

                    <span class="ml-1">
                      Lampiran
                    </span>
                  </v-btn>
                </div>

                <div v-if="selected.row.length === 1"
                  class="mr-3" >
                  <v-btn
                    elevation="0"
                    style="border-radius: 10px;"
                    :style="`background: ${set_color_rgb}; color: ${set_color};`"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center"
                    @click="toMap()">
                    <v-icon size="18">mdi-map-marker-circle</v-icon>

                    <span class="ml-1">
                      Map
                    </span>
                  </v-btn>
                </div>
              </v-col>
                
              <v-col 
                cols="12" 
                md="4" 
                class="d-flex align-center justify-end">
                <v-text-field
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari . . ."
                  vvvv-uppercase
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search"
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  style="border-radius: 10px;">
                </v-text-field>

                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :color="set_color"
                        elevation="0"
                        min-width="36"
                        class="text-capitalize white--text px-0"
                        style="border-radius: 10px;"
                        :disabled="process.print"
                        :loading="process.print"
                        @click="prints()"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon>mdi-microsoft-excel</v-icon>
                      </v-btn>
                    </template>
                    
                    <span>
                      Print
                    </span>
                  </v-tooltip>
                </div>

                <!-- FREEZE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        :color="set_color"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div>

                <!-- HIDE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '274px' : '202px'})`"
            :show-select="checkbox"
            :single-select="true"
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="configHeaders"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            @dblclick:row="doubleClick"
            hide-default-footer>
            <template
              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
              v-slot:[`item.${header.value}`]="{ value }">
              {{ rowFormat(header.format, value) }} 
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ lastIndex + index }}
            </template>

            <v-progress-linear 
              v-show="process.load" 
              slot="progress" 
              color="white" 
              indeterminate>
            </v-progress-linear>
          </v-data-table>

          <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)" 
            :model="pagination"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          attachment: false,
          map: false
        },
        search: '',
        filter: {
          unit: ''
        },
        selected: {
          row: [],
          freeze: []
        },

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },
        markers: [],
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 15,
            height: -10
          }
        },

        options: {},
        headers: [],
        list: [],
        unit: [],
        pagination: {},
        lastIndex: 0,
        limit: 20,
        process: {
          load: false,
          print: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      }
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      }
    },
    mounted () {
      // this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value.split('.')[0]
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          },00`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          // data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          unit_id: this.filter.unit
        }

        this.selected.row = []

        await get('admin/report', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Nama Lengkap',
                width: '400px',
                value: 'user_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Judul',
                width: '400px',
                value: 'title',
                freeze: false,
                hide: false
              },
              {
                text: 'Deskripsi',
                width: '400px',
                value: 'desc',
                freeze: false,
                hide: false
              },
              {
                text: 'Latitude',
                width: '200px',
                value: 'latitude',
                freeze: false,
                hide: false
              },
              {
                text: 'Longitude',
                width: '200px',
                value: 'longitude',
                freeze: false,
                hide: false
              },
              {
                text: 'Tanggal Dibuat',
                width: '200px',
                value: 'datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              }
            ]
            
            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      // PRINT
      async prints () {
        this.message.error = ''

        this.process.print = true

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/report/export`,
          method: 'GET',
          responseType: 'blob', // important,
          // params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.xls`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.print = false
            this.message.error = res.message
          }
        })
      },

      // UNIT
      async fetchUnit () {
        let params = {
          limit: 100000
        }

        this.unit = []

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.unit.push({
                text: obj.name,
                value: obj.id
              })
            })
          }
        })
      },

      // MAP
      toMap () {
        this.markers = []

        this.dialog.map = true

        this.$gmapApiPromiseLazy().then(() => {
          let data = this.selected.row[0]

          this.markers.push({
            title: data.title,
            name: data.user_name,
            attachment: data.attachment,
            datetime: data.datetime,
            latlng: {
              lat: parseFloat(data.latitude), 
              lng: parseFloat(data.longitude)
            },
            icon: {
              url: require('@/assets/image/location_pin.png'),
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10)
            }
          })

          this.center = this.markers.length > 0 ? this.markers[0].latlng : this.center
        })
      },
      toggleInfoWindow(marker, idx) {
        this.infoWindowPos = marker.latlng
        this.infoContent = this.getInfoWindowContent(marker)
        
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },
      getInfoWindowContent(marker) {
        let data = marker

        data.attachment = data.attachment === '' ? require('@/assets/image/image_default.png') : data.attachment

        return (`
          <div id="iw-container">
            <div class="iw-title">
              ${data.title}
            </div>

            <div class="iw-content">
              <img 
                class="image"
                height="100" 
                width="100"
                src="${data.attachment}">

              <div class="iw-subTitle" style="margin-bottom: 10px;">
                ${data.name}
              </div>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Tanggal & Waktu
              </p>

              <p style="margin-bottom: 14px; font-weight: bold;">
                ${moment(data.datetime).format('D MMM, YYYY')} Pukul ${moment(data.datetime).format('HH:mm')}
              </p>
            </div>
          </div>
        `)
      }
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }
</style>